import { TableColumn } from 'react-data-table-component';
import { Link } from 'react-router-dom';

import { HubDevice } from 'api/traps/DevicesWareHouse/types';
import { Breakpoints } from 'hooks/Screen/useScreenSize';
import LinkCell from 'components/TrapsTables/Cells/LinkCell/LinkCell';
import { useHubDeleteModalStore } from 'components/DeleteHubModal/HubsDeleteStore';

export const useGetTableHubColumns = (isAll: boolean): TableColumn<HubDevice>[] => {
  const { openDeleteHubModal } = useHubDeleteModalStore();

  const columns: TableColumn<HubDevice>[] = [
    {
      name: 'Serial Number',
      selector: row => row.serial_number,
      sortable: true,
      sortField: 'serial_number',
    },
  ];

  if (isAll) {
    columns.unshift({
      name: 'Number',
      selector: row => row.model_trap_type,
      sortable: true,
      sortField: 'sequence_number',
      cell: row =>
        row.is_used ? (
          <LinkCell
            title={String(row.is_used.sequence_number) || 'None'}
            link={`/hub/info/${row.serial_number.toLowerCase()}/`}
            toReact
            icon="ri-eye-line"
          />
        ) : (
          <LinkCell title="None" link="#" toReact icon="ri-eye-line" />
        ),
    });

    columns.splice(2, 0, {
      name: 'Use site',
      selector: row => row.object_name,
      hide: Breakpoints.Tablet,
      sortField: 'object_name',
      sortable: true,
      cell: row =>
        row.is_used ? (
          <Link to={`/object/traps/${row.object_slug}`} className="link-cell-item text-truncate">
            <div className="icon">
              <i className="ri-external-link-fill icon rounded-pill fs-14 me-1" />
            </div>

            <div className="text w-100 d-flex align-items-center justify-content-center">
              <span>{row.is_used.site_name || 'None'}</span>
            </div>
          </Link>
        ) : (
          <Link to="#" className="link-cell-item text-truncate">
            <div className="icon">
              <i className="ri-external-link-fill icon rounded-pill fs-14 me-1" />
            </div>

            <div className="text w-100 d-flex align-items-center justify-content-center">
              <span>None</span>
            </div>
          </Link>
        ),
    });

    columns.push({
      name: 'Actions',
      selector: row => row.serial_number,
      hide: Breakpoints.Mobile,
      cell: _row => (
        <button
          type="button"
          className="btn btn-sm btn-ghost-primary btn-icon"
          onClick={() => openDeleteHubModal(_row.serial_number, _row.id, _row.traps_connected, _row.object_slug)}
        >
          <i className="ri-delete-bin-6-fill icon icon__delete" />
        </button>
      ),
    });
  }

  if (!isAll) {
    columns.splice(1, 0, {
      name: 'Model',
      selector: row => row.model_trap_type,
      sortable: true,
      sortField: 'model_trap_type',
      hide: Breakpoints.Mobile,
    });
    columns.push({
      name: 'Actions',
      selector: row => row.serial_number,
      cell: _row => (
        <button
          type="button"
          className="btn btn-sm btn-ghost-primary btn-icon"
          onClick={() => openDeleteHubModal(_row.serial_number, _row.id, _row.traps_connected, _row.object_slug)}
        >
          <i className="ri-delete-bin-6-fill icon icon__delete" />
        </button>
      ),
    });
  }

  return columns;
};
